import formatError from "@/utils/formatError";
import { t } from "i18next";
import { toast } from "react-toastify";

type IToastBody = string | unknown;
type IToastType = "error" | "warning" | "info" | "success";
interface IToast {
  data: IToastBody;
  type: IToastType;
}

interface IToastConfig {
  [key: string]: { message: string; type: IToastType };
}

const handleToastConfig: IToastConfig = {
  INVALID_KLAVIYO_API_KEY: {
    message: t("emailOnboarding.klaviyoApiKey.invalidApiKey"),
    type: "error",
  },
  NotCompromisedPassword: {
    message: t("auth.resetPassword.compromisedPassword"),
    type: "error",
  },
  INVALID_LIST_TYPE: {
    message: t("settings.integration.klaviyoLists.modal.invalidListType"),
    type: "error",
  },
  EXPIRED_TOKEN: {
    message: t("auth.resetPassword.expiredToken"),
    type: "error",
  },
};

const errorsToIgnore = [
  "EXPIRED_VERIFICATION_CODE",
  "INVALID_VERIFICATION_CODE",
  "INVALID_KLAVIYO_API_KEY",
  "WORK_EMAIL_REQUIRED",
  "INTEGRATION_INSTALLATION_NOT_FOUND",
  "CHECK_EMAIL",
  "Email",
  "INTEGRATION_NOT_FOUND",
];

const errorStatusesToIgnore = [401];

const filterIgnoredErrorByCode = (code: string) =>
  errorsToIgnore.includes(code);

const filterIgnoredErrorByStatus = (status?: number | string) =>
  typeof status === "number" && errorStatusesToIgnore.includes(status);

const getMatchedErrorMessagedFromCode = (codes?: string[]) => {
  if (!codes) return [t("generic.error")];

  return codes?.map(code => {
    const matchingMessage = handleToastConfig[code]?.message;

    if (filterIgnoredErrorByCode(code)) {
      return;
    }
    if (!matchingMessage) return t("generic.error");

    return matchingMessage;
  });
};

const getErrorMessage = (errorOrErrors: IApiError) => {
  if (!errorOrErrors) return;

  const formattedError = formatError(errorOrErrors);

  const errorToDisplay = getMatchedErrorMessagedFromCode(formattedError?.codes);

  if (filterIgnoredErrorByStatus(formattedError.status)) return;

  if (!errorToDisplay) return;

  return errorToDisplay;
};

const handleToasts = ({ data, type }: IToast) => {
  if (type === "error") {
    const errors = getErrorMessage(data as IApiError);

    errors?.forEach(singleError => {
      if (singleError) toast.error(singleError);
    });
  } else if (typeof data === "string") {
    toast(data, { type });
  }
};
export default handleToasts;
